export function areArraysEqual(array1: number[] | undefined, array2: number[] | undefined) {
  if (!array1 || !array2) return false;
  if (array1.length !== array2.length) {
    return false;
  }
  return array1.every((value) => array2.includes(value));
}
